/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface ProposedActionItem
 */
export interface ProposedActionItem {
  /**
   *
   * @type {string}
   * @memberof ProposedActionItem
   */
  content: string;
  /**
   *
   * @type {string}
   * @memberof ProposedActionItem
   */
  defaultAssignee?: string | null;
}

/**
 * Check if a given object implements the ProposedActionItem interface.
 */
export function instanceOfProposedActionItem(
  value: object,
): value is ProposedActionItem {
  if (!("content" in value) || value["content"] === undefined) return false;
  return true;
}

export function ProposedActionItemFromJSON(json: any): ProposedActionItem {
  return ProposedActionItemFromJSONTyped(json, false);
}

export function ProposedActionItemFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ProposedActionItem {
  if (json == null) {
    return json;
  }
  return {
    content: json["content"],
    defaultAssignee:
      json["defaultAssignee"] == null ? undefined : json["defaultAssignee"],
  };
}

export function ProposedActionItemToJSON(json: any): ProposedActionItem {
  return ProposedActionItemToJSONTyped(json, false);
}

export function ProposedActionItemToJSONTyped(
  value?: ProposedActionItem | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    content: value["content"],
    defaultAssignee: value["defaultAssignee"],
  };
}
